import {Img} from '@react-email/components'

export const ComponentEmailLogo = () => {
    return (
        <Img src={"/images/logo.svg"} width={80} height={77} alt={""} />
    )
}